<img
  [alt]="'language.' + code | transloco"
  [src]="'/assets/images/flags/flag-' + code + '.svg'" />
